import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=9f0ddb2a"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=9f0ddb2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports